export function smoothScrollToAnchor(_sel) {
	_sel.addEventListener('click', function(e) {
		e.preventDefault();

		if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
			document.querySelector('.site-navigation__navicon').click();
		}

		if (e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__sub-menu')) {
			e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
		}

		if (e.target.parentNode.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__menu-item')) {
			e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
		}

		if (e.currentTarget.href.includes('#') && document.getElementById(e.currentTarget.href.split('#')[1])) {
			const targetElement = document.getElementById(e.currentTarget.href.split('#')[1]);
			const header = document.querySelector('.site-header');
			const headerHeight = header ? header.offsetHeight + 20 : 0;
			const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
			// Smoothly scroll to the calculated position
			window.scrollTo({ top: targetPosition });
		} else {
			window.location.href = e.currentTarget.href;
		}
	});
}
